import { createContext } from 'react';
import { Persistor } from 'redux-persist';

export const PersistContext = createContext<Persistor | null>(null);

export const PersistProvider = PersistContext.Provider;
